const SPACING = "24px";

export const getStyles = (type: string, isShowing: boolean) => ({
  styles: {
    container: {
      alignItems: "center",
      background: type === "error" ? "#FEDCDA" : "#D3EDE6",
      borderRadius: "8px",
      color: "#333333",
      display: "flex",
      height: "108px",
      padding: "20px 24px",
      position: "fixed" as "fixed",
      right: SPACING,
      top: SPACING,
      // animations
      transform: isShowing ? "translateX(0)" : `translateX(calc(100% + ${SPACING}))`,
      transition: "transform 0.3s ease-in-out",
      width: "505px",
      zIndex: 1301,
    },
    title: {
      color: "#333333",
      fontSize: "24px",
      fontWeight: "500",
      lineHeight: "32px",
      margin: 0,
    },
    text: {
      fontSize: "14px",
      lineHeight: "16px",
      margin: 0,
    },
    icon: {
      display: "flex",
      marginRight: "24px",
    },
  },
});
